import EditableCell from './EditableCell'

export default EditableCell
